export const iconFontAwesomeUsersPeoplePersonDress = (
	<i className="fa-solid fa-person-dress"></i>
);
